import React from 'react';
import ClickableStyled from './bundle.esm2.js';

const Clickable = (props) => {
  const { className, children, padding = 16, onClick } = props;
  if (!children) {
    throw new Error(`${Clickable.displayName}: You need to specify children`);
  }
  return /* @__PURE__ */ React.createElement(ClickableStyled, {
    className: `Clickable ${className}`,
    onClick,
    padding
  }, children);
};
Clickable.defaultProps = {
  className: "",
  padding: 16
};

export { Clickable as default };
//# sourceMappingURL=bundle.esm.js.map
